import { Directive, ElementRef, HostBinding, Input, OnChanges, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

import { FormsService } from '../../services/forms';
import { FormEditorInputType } from '../../shared/components';

/**
 * Utility directive for getting, setting and hiding/showing form error message.
 *
 * Usage:
 * <mat-error
 *     appFormErrorMessage
 *     [type]="formEditorInputType.text"
 *     [errorFormControl]="formInputs.controls.id"
 * ></mat-error>
 */
@Directive({
	selector: '[appFormErrorMessage]'
})
export class FormErrorMessageDirective implements OnChanges {
	@Input() type: FormEditorInputType;
	@Input() errorFormControl: AbstractControl;

	@HostBinding('style.display') display: 'block' | 'none' = 'none';

	constructor(private elRef: ElementRef, private formsService: FormsService) {}

	public ngOnChanges(): void {
		if (this.errorFormControl) {
			this.errorFormControl.valueChanges.subscribe(() => this.getError());
			this.errorFormControl.statusChanges.subscribe(() => this.getError());
		}

		this.getError();
	}

	private getError(): void {
		if (this.errorFormControl?.invalid) {
			this.elRef.nativeElement.innerHTML = this.formsService.getErrorMessage(this.errorFormControl, this.type);
			this.display = 'block';
		} else {
			this.display = 'none';
		}
	}
}
